import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const ConfirmationCancelEditDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
    >
      <DialogTitle>Confirmar</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Hay cambios sin guardar. ¿Estás seguro de que deseas salir sin guardar?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onConfirm} color="primary">
          Salir sin guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationCancelEditDialog;